import React, { Component } from 'react'
import ProfileDetails from './ProfileDetails'
import EditProfile from './EditProfile'
import { GetUserLogin, Alerts } from '../../../helpers'
export default class Profile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            isEdit: false,
            profile: {}
        }
    }

    onEdit = () => {
        this.setState({
            isEdit: true
        });
    }
    goBack = (e) => {
        this.setState({
            isEdit: false,
        });
    }

    onEditSubmit = async (data) => {
        let resp = await GetUserLogin.getUserProfileUpdate(data);
        if (resp) {
            console.log(resp);
            this.getUser();
            this.setState({
                isEdit: false
            })
            sessionStorage.setItem('userData', JSON.stringify(resp.userData));
            Alerts.alertMessage(resp.message, "Thank You !", "success");
        }

    }
    getUser = async () => {
        let resp = await GetUserLogin.getUserDetails();
        if (resp) {
          console.log(resp);
            this.setState({
                profile: resp,
                isLoading: false,
            })
        }
    }
    componentDidMount() {
        this.getUser();
    }
    render() {
        const { isEdit, isLoading, profile } = this.state;
        console.log(profile);
        return (
            <>
                {
                         isLoading ? 'Data Loading...' :
                        !isEdit ? <ProfileDetails data={profile}  onEdit={this.onEdit} /> : <EditProfile goBack={this.goBack} data={profile} onEditSubmit={this.onEditSubmit} />
                }
            </>
        )
    }
}
